import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { V2DualPillComponent } from '../../dual-pill/v2-dual-pill.component';
import { V2LightweightRuleEngineComponent } from '../v2-lightweight-rule-engine.component';
import { CONDITION_LABELS, LightWeightCondition } from '../util/types-constants';

@Component({
  selector: 'coin-rule-engine-condition-picker',
  templateUrl: './condition-picker.component.html',
  styleUrls: ['./condition-picker.component.scss'],
  imports: [V2DualPillComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConditionPickerComponent {
  currentCondition = input.required<LightWeightCondition>();
  changed = output<LightWeightCondition>();

  protected ruleEngine = inject(V2LightweightRuleEngineComponent);

  protected currentConditionLabel = computed(() => CONDITION_LABELS[this.currentCondition()]);

  protected toggleCondition(): void {
    this.changed.emit(this.currentCondition() === 'Or' ? 'And' : 'Or');
  }
}
